<template>
    <v-card stretch>
        <v-row justify-content="center">
            <v-col xs="8">
                <v-tabs :tabs="tabs" :selected="selected" @click="selected = $event"/>
            </v-col>
        </v-row>

        <v-separator />

        <inn-form v-if="selected === 'inn'" :isIndividual="isIndividual" :on-create="onCreate" :total="total" />
        <search-form v-else @search="$emit('search', $event)" :is-searching="isSearching" :is-individual="isIndividual" :total="total" :on-create="onCreate" />
    </v-card>
</template>

<script>
    import InnForm from './InnForm.vue';
    import SearchForm from './SearchForm.vue';

    export default {
        name: 'request-egr',
        props: {
            onCreate: Function,
            isIndividual: Boolean,
            isSearching: Boolean,
            total: Number,
        },
        components: {
            InnForm,
            SearchForm,
        },
        data() {
            return {
                selected: 'inn',
                tabs: {
                    inn: { label: this.isIndividual ? 'ИНН' : 'ИНН или ОГРН', active: true },
                    search: { label: this.isIndividual ? 'Поиск по ФИО' : 'Поиск по названию организации', active: true },
                }
            }
        },
        methods: {}
    }
</script>


// WEBPACK FOOTER //
// RequestEgr.vue?4294ae0d